// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3sHxO","containerItemsCenter":"Skeleton_containerItemsCenter__Zlfj8"};